<template>
    <el-dialog width="800px" title="采购退货" :before-close="handleClickCancel" class="custom-height-dialog" :close-on-press-escape="false"
               :close-on-click-modal="false" :visible.sync="purchaseReturnGoodsVisible" append-to-body>
        <div class="detail" v-loading="loading">
            <el-form size="small" ref="purchaseForm"   v-loading="loading" label-position="top"   :model="purchaseFormData"  :rules="purchaseFormDataRules">
                <el-row :gutter="20" type="flex">
                    <el-col :span="12">
                        <el-form-item label="采购单编号" prop="purchase_num">
                            <el-input disabled v-model="purchaseFormData.purchase_num"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="供应商名称" prop="supplier_name">
                            <el-input disabled  v-model="purchaseFormData.supplier_name"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20" >
                    <el-col :span="24">
                        <el-form-item label="退货产品明细" prop="return_details">
                            <el-table :data="purchaseFormData.return_details" border  show-summary  :summary-method="getPurchaseSummaries" class=" custom_table">
                                <el-table-column label="退货产品" prop="product_name"  class-name="tableInputColumn" width="194">
                                    <template slot-scope="{row}">
                                        <el-select v-if="!row.product_name" v-model="row.id" placeholder="请选择" @change="handleChangeProduct($event,row)" filterable remote>
                                            <el-option  :key="item.product_name" :label="item.product_name" :value="item.id" :disabled="purchaseFormData.return_details.find(find => find.id == item.id) ? true : false" v-for="item in productAllList"> </el-option>
                                        </el-select>
                                        <span v-else v-text="row.product_name"> </span>
                                    </template>
                                </el-table-column>
                                <el-table-column align="right" label="退货数量" prop="num"   class-name=" tableInputColumn" width="110">
                                    <template slot-scope="{row}">
                                        <el-input-number v-model="row.num" :controls="false" :min="0" :max="row.max_num" :precision="0" @blur="handleCountPurchaseTotalPrice(row)"  placeholder="请输入数量"></el-input-number>
                                    </template>
                                </el-table-column>
                                <el-table-column align="right" label="单价（元）"  prop="price"   width="96">  </el-table-column>
                                <el-table-column align="right" label="小计金额（元）" prop="total_price"  width="154">
                                    <template slot-scope="{row}">
                                        <span v-text="row.total_price ? row.total_price : '系统计算'"></span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="退货说明" prop="note"  class-name="tableInputColumn">
                                    <template slot-scope="{row}">
                                        <el-input v-model="row.note"  placeholder="请输入"></el-input>
                                    </template>
                                </el-table-column>

                                <el-table-column fixed="right" label="操作" width="54">
                                    <template slot-scope="{row,$index}">
                                      <span class="handle_icon_wrap handle_icon_danger_wrap" @click="purchaseFormData.return_details.splice($index,1);handleCountPurchaseTotalPrice()">
                                          <i class="iconfont icon-shanchu1"></i>
                                      </span>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <div class="add_custom_btn" v-if="purchaseFormData.return_details.length != productAllList.length">
                               <span @click="handleClickPurchaseReturnAdd()">
                                    <i class="el-icon-plus"></i> 新增行
                               </span>
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="退款总金额" prop="total_price">
                            <el-input  v-model="purchaseFormData.total_price" placeholder="系统公式自动计算 可修改"  ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="18">
                        <el-form-item label="附件" prop="files">
                            <div class="file_upload_wrap">
                                <div v-if="purchaseFormData.files.length===0" class="file_outer_wrap">
                                    <img alt=""  src="https://download.hecoos.com/enlightv/2023-31/3wy8ZnscPAjXMD2XmQhb.png"  width="36">
                                    <p class="file_hint">点击或者将文件拖拽到这里上传</p>
                                    <p class="file_type_hint">支持.rar .zip .doc .docx .pdf .jpg...</p>
                                    <input class="upload_input"  multiple type="file" @change="handleUploadFileChange($event)">
                                </div>
                                <ul v-else class="upload_file_list">
                                    <li v-for="(file,file_idx) in purchaseFormData.files" :key="file_idx" class="upload_file_item">
                                        <div class="file_left_wrap">
                                            <img alt="" class="file_img"  src="https://download.hecoos.com/enlightv/2023-37/chyZ4zyQiQkR5byRwSCT.png">
                                            <div class="file_info_wrap">
                                                <p class="file_name" v-text="file.file_name"></p>
                                                <p class="file_size" v-text="file.file_size"></p>
                                            </div>
                                        </div>
                                        <div class="file_right_wrap">
                                            <el-tooltip content="预览"  effect="dark"  placement="top">
                                            <span class="handle_icon_wrap" @click="handleClickPreview(file)">
                                                <i class="iconfont icon-yanjing"></i>
                                            </span>
                                            </el-tooltip>
                                            <span class="line"></span>
                                            <el-tooltip content="删除"  effect="dark"  placement="top">
                                            <span class="handle_icon_wrap handle_icon_danger_wrap"  @click="purchaseFormData.files.splice(file_idx,1)">
                                                <i class="iconfont icon-shanchu1"></i>
                                            </span>
                                            </el-tooltip>
                                        </div>
                                    </li>
                                    <li class="upload_file_btn_wrap">
                                        <i class="el-icon-plus"></i>
                                        <span>添加附件</span>
                                        <input class="upload_input"  multiple  type="file"  @change="handleUploadFileChange($event)">
                                    </li>
                                </ul>
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="18">
                        <el-form-item label="退货备注" prop="note">
                            <el-input type="textarea" :rows="5" v-model="purchaseFormData.note" placeholder="请输入备注信息"  maxlength="600"  show-word-limit></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <approveProcessSelect ref="approveProcessSelectRef" :approval_node_list="approval_node_list"></approveProcessSelect>
            </el-form>
            <el-image :preview-src-list="previewImgList" :src="previewImgSrc" ref="preview_img" style="display: none"></el-image>
        </div>
        <div slot="footer">
            <el-button size="small" :disabled="BtnDisabled" @click="handleClickCancel">取消</el-button>
            <el-button size="small" type="primary" :disabled="BtnDisabled" @click="handleClickConfirm">提交</el-button>
        </div>
    </el-dialog>
</template>
<script>
import {PurchaseReturnDetail,getApprovalNodes,PurchaseReturn} from '@/api'
import {formatFileSize} from "@/utils";
import {getOSSData, uploadImg} from "@/utils/uploadOss";
import approveProcessSelect from "@/components/pComponents/approveProcessSelect";

export default {
    name: 'purchase_returnGoods',
    components: {
        approveProcessSelect
    },
    props: {
        purchaseReturnGoodsVisible: {
            type: Boolean,
            default: false,
        },
        purchaseId: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            loading:false,
            BtnDisabled: false,
            purchaseFormData: {
                supplier_name:'',
                purchase_num:'',
                return_details:[],
                total_num:0,
                total_price:'',
                files:[],
                note:'',
            },
            purchaseFormDataRules:{

            },
            previewImgList: [],
            previewImgSrc: "",
            approval_node_list:[],
            productAllList:[]
        }
    },
    created() {
        this.getPurchaseReturnDetail()
        this.getApprovalNodes()
    },
    computed: {

    },
    mounted() {

    },
    methods: {

        // 采购计算金额
        handleCountPurchaseTotalPrice(row){
            if(row){
                this.$set(row,'total_price',Number(row.num) * Number(row.price))
            }
            let total_price = 0
            let total_num  = 0
            this.purchaseFormData.return_details.forEach(item=>{
                total_price += item.total_price ?  Number(item.total_price) :0
                total_num += item.num ?  Number(item.num) :0
            })

            this.$set(this.purchaseFormData, 'total_num', total_num)
            this.$set(this.purchaseFormData, 'total_price', total_price)
        },

        // 新增行
        handleClickPurchaseReturnAdd(){
            let json = {
                purchase_id:'',
                id:'',
                product_name:'',
                num:'',
                stock_id:'',
                price:'',
                total_price:'',
                sku_id:'',
                sku_key:'',
                note:''
            }
            this.purchaseFormData.return_details.push(json)
        },
        // 选择产品
        handleChangeProduct(event,row){
            let info = this.productAllList.find(find => find.id == event)
            if(info){
                for (let infoKey in info) {
                    this.$set(row,infoKey,info[infoKey])
                }
                this.$set(row,'note','')
            }
            this.handleCountPurchaseTotalPrice()
        },
        //  采购明细表格合计行
        getPurchaseSummaries(param){
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '';
                    return;
                }

                if(column.property == 'num'){
                    sums[index] = data.reduce((prev, curr) => {
                        const value = Number(curr[column.property]);
                        if (!isNaN(value)) {
                            return prev + curr[column.property];
                        } else {
                            return prev;
                        }
                    }, 0);
                    sums[index] = '总数量：' + Number(sums[index]);
                }
                if(column.property == 'total_price'){
                    sums[index] = data.reduce((prev, curr) => {
                        const value = Number(curr[column.property]);
                        if (!isNaN(value)) {
                            return prev + Number(curr[column.property]);
                        } else {
                            return prev;
                        }
                    }, 0);
                    sums[index] = '总金额：' + Number(sums[index]).toFixed(2);
                }

            });
            return sums;
        },

        // 获取审批流
        getApprovalNodes(){
            this.approval_node_list = []
            getApprovalNodes({
                approval_type: 'purchase_return',
            }).then(res => {
                if (res.code === 200) {
                    this.approval_node_list = res.data
                    this.$refs.approveProcessSelectRef.set_approval_node_list(res.data)
                } else {
                    this.$message.error(res.message)
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },

        // 获取
        getPurchaseReturnDetail(){
            PurchaseReturnDetail({
                purchase_id: this.purchaseId
            }).then(res => {
                if (res.code === 200) {
                   this.purchaseFormData.supplier_name = res.data.supplier_name
                   this.purchaseFormData.purchase_num = res.data.purchase_num

                    res.data.purchase_details.forEach(item=>{
                        this.handleCountPurchaseTotalPrice(item)
                        this.$set(item,'max_num',item.num)
                    })
                   this.purchaseFormData.return_details = res.data.purchase_details
                   this.productAllList = JSON.parse(JSON.stringify(res.data.purchase_details))
                    this.handleCountPurchaseTotalPrice()
                } else {
                    this.$message.error(res.message)
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },

        // 上传附件
        handleUploadFileChange(e){
            const files = e.target.files
            const that = this;
            Array.from(files).forEach(file => {
                uploadImg(file, 50).then(res => {
                    if (res.file_path) {
                        res.file_size = formatFileSize(file.size)
                        this.purchaseFormData.files.push(res)
                        e.target.value = ''
                    }
                    e.target.value = ''
                }).catch(error => {
                    e.target.value = ''
                })
            })
        },

        // 预览
        handleClickPreview(file){
            if (file.file_type.indexOf("image") > -1) {
                this.previewImgList = [file.file_path];
                this.previewImgSrc = file.file_path;
                this.$refs.preview_img.showViewer = true;
            } else {
                if (file.file_type.indexOf("pdf") > -1) {
                    window.open(file.file_path);
                } else {
                    this.$message.error("当前文件格式不支持预览，请下载后查看");
                }
            }
        },

        //取消事件
        handleClickCancel() {
            //关闭对话框
            this.$emit('update:purchaseReturnGoodsVisible', false)
        },
        handleClickConfirm(){
            if(this.$refs.approveProcessSelectRef.handleClickPublish() == false){  //审批节点校验没通过
                return false
            }

            let return_details = []
            this.purchaseFormData.return_details.forEach(item=>{
                if(item.num){
                    let json = {
                        id: item.id,
                        purchase_id: item.purchase_id,
                        product_name:  item.product_name,
                        sku_id:  item.sku_id,
                        sku_key:  item.sku_key,
                        num: item.num,
                        price: item.price,
                        total_price: item.total_price,
                        note:  item.note,
                    }
                    return_details.push(json)
                }

            })
            if(return_details.length  == 0){return  this.$message.error('请至少退一个产品')}
            let postData = {
                purchase_id: this.purchaseId,
                supplier_name: this.purchaseFormData.supplier_name,
                purchase_num:  this.purchaseFormData.purchase_num,
                return_details:return_details,
                total_num:this.purchaseFormData.total_num,
                total_price:this.purchaseFormData.total_price,
                files:this.purchaseFormData.files,
                note:this.purchaseFormData.note,
                node_list:this.approval_node_list
            }
            this.BtnDisabled = true;
            PurchaseReturn(postData).then(res => {
                if (res.code === 200) {
                    this.$message.success(res.message)
                    this.$emit('success')
                    this.$emit('update:purchaseReturnGoodsVisible', false)
                } else {
                    this.BtnDisabled = false;
                    this.$message.error(res.message)
                }
            }).catch(() => {
                this.BtnDisabled = false;
            })

        },
    },

}
</script>
<style lang="scss" scoped>
.label-bold {
    ::v-deep .el-form-item__label {
        font-size: 14px;
        font-weight: 700;
        letter-spacing: 0px;
        line-height: 22px;
        color: rgba(51, 51, 51, 1);
    }
}
.file_outer_wrap {
    height: 156px;
    opacity: 1;
    border-radius: 6px;
    background: #EDF0F4;
    border: 1px dashed #D9D9D9;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    cursor: pointer;
    position: relative;

    .upload_input {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        z-index: 100;
        opacity: 0;
        cursor: pointer;
        width: 100%;
    }

    .file_hint {
        margin-top: 12px;
        margin-bottom: 4px;
        line-height: 22px;
        color: #666666;
    }

    .file_type_hint {
        color: #999999;
        font-size: 12px;
        line-height: 18px;
    }
}
.file_upload_wrap{
    width: 100%;
    height: 156px;
}
.add_custom_btn{
    text-align: center;
    span{
        height: 32px;
        border-radius: 4px;
        background: rgba(255, 255, 255, 1);
        padding: 0 16px;
        border: 1px solid rgba(41, 144, 255, 1);
        box-sizing: border-box;
        display: inline-block;
        margin: 16px auto 0;
        font-size: 14px;
        color: rgba(41, 144, 255, 1);
        cursor: pointer;
    }
}
</style>

